<template>
    <svg
        :width="size"
        :height="size"
        viewBox="0 0 24 24"
        :fill="color"
        xmlns="http://www.w3.org/2000/svg"
        :style="{ color }"
    >
        <path
            v-if="filled"
            d="M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM12 4.8C11.3373 4.8 10.8 5.33726 10.8 6V13.2C10.8 13.8627 11.3373 14.4 12 14.4C12.0339 14.4 12.0674 14.3986 12.1006 14.3958L18 14.3952C18.6627 14.3952 19.2 13.8579 19.2 13.1952C19.2 12.5324 18.6627 11.9952 18 11.9952L13.2 11.994V6C13.2 5.33726 12.6627 4.8 12 4.8Z"
        />
        <path
            v-else
            d="M12 24C13.6563 24 15.2148 23.6875 16.6758 23.0625C18.1367 22.4375 19.4102 21.582 20.4961 20.4961C21.582 19.4102 22.4375 18.1367 23.0625 16.6758C23.6875 15.2148 24 13.6563 24 12C24 10.3438 23.6875 8.78516 23.0625 7.32422C22.4375 5.86328 21.582 4.58984 20.4961 3.50391C19.4102 2.41797 18.1367 1.5625 16.6758 0.9375C15.2148 0.3125 13.6563 0 12 0C10.3438 0 8.78516 0.3125 7.32422 0.9375C5.86328 1.5625 4.58984 2.41797 3.50391 3.50391C2.41797 4.58984 1.5625 5.86328 0.9375 7.32422C0.3125 8.78516 0 10.3438 0 12C0 13.6563 0.3125 15.2148 0.9375 16.6758C1.5625 18.1367 2.41797 19.4102 3.50391 20.4961C4.58984 21.582 5.86328 22.4375 7.32422 23.0625C8.78516 23.6875 10.3438 24 12 24ZM12 22.5234C10.5469 22.5234 9.18359 22.2461 7.91016 21.6914C6.63672 21.1367 5.52734 20.3828 4.58203 19.4297C3.63672 18.4766 2.88672 17.3633 2.33203 16.0898C1.77734 14.8164 1.5 13.4531 1.5 12C1.5 10.5469 1.77734 9.18359 2.33203 7.91016C2.88672 6.63672 3.63672 5.52734 4.58203 4.58203C5.52734 3.63672 6.63672 2.88672 7.91016 2.33203C9.18359 1.77734 10.5469 1.5 12 1.5C13.4531 1.5 14.8164 1.77734 16.0898 2.33203C17.3633 2.88672 18.4727 3.63672 19.418 4.58203C20.3633 5.52734 21.1133 6.63672 21.668 7.91016C22.2227 9.18359 22.5 10.5469 22.5 12C22.5 13.4531 22.2227 14.8164 21.668 16.0898C21.1133 17.3633 20.3633 18.4766 19.418 19.4297C18.4727 20.3828 17.3633 21.1367 16.0898 21.6914C14.8164 22.2461 13.4531 22.5234 12 22.5234ZM10.2857 13.9286V6.21429C10.2857 5.7409 10.6695 5.35714 11.1429 5.35714C11.6162 5.35714 12 5.7409 12 6.21429V12.2143H18.004C18.4774 12.2143 18.8611 12.598 18.8611 13.0714C18.8611 13.5448 18.4774 13.9286 18.004 13.9286H10.2857Z"
        />
    </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
    name: 'TimeSVG',
    props: {
        size: VueTypes.number.isRequired,
        color: VueTypes.string.isRequired,
        filled: VueTypes.bool.def(false),
    },
};
</script>
